// Enhance Dawn's native gallery without replacing its variant/media lifecycle.
if (!customElements.get('tmx-accessory-gallery')) {
  customElements.define('tmx-accessory-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      customElements.whenDefined('media-gallery').then(() => {
        if (!this.isConnected || signal.aborted) return;
        const gallery = this.querySelector('media-gallery');
        const viewer = gallery?.querySelector('[id^="GalleryViewer"]');
        if (!viewer || typeof gallery.setActiveMedia !== 'function') return;
        const order = (this.dataset.mediaOrder || '').split(',').filter(Boolean)
          .map(id => this.dataset.section + '-' + id);
        const arrows = this.querySelector('.tmx-accessory__arrows');
        if (order.length < 2 || !arrows) return;
        arrows.hidden = false;
        const step = direction => {
          const selected = gallery.querySelector('[data-target]:has(button[aria-current="true"])')?.dataset.target
            || viewer.querySelector('.is-active[data-media-id]')?.dataset.mediaId;
          const index = Math.max(0, order.indexOf(selected));
          gallery.setActiveMedia(order[(index + direction + order.length) % order.length], false);
        };
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-tmx-gallery-step]');
          if (button && this.contains(button)) step(Number(button.dataset.tmxGalleryStep));
        }, {signal});
        this.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || event.altKey || event.ctrlKey || event.metaKey) return;
          if (event.target.closest('input,textarea,select,video,model-viewer,[contenteditable]')) return;
          event.preventDefault();
          step(event.key === 'ArrowRight' ? 1 : -1);
        }, {signal});
        const resize = () => this.style.setProperty('--tmx-gallery-center', viewer.getBoundingClientRect().height / 2 + 'px');
        this.observer?.disconnect();
        this.observer = new ResizeObserver(resize);
        this.observer.observe(viewer);
        resize();
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}
